import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

interface PropertyTypeInputProps {
    value?: string[];
    onChange: (value: string[]) => void;
}

const PROPERTY_TYPES = [
    { value: "house", label: "Home" },
    { value: "condo", label: "Condo" },
];

const PropertyTypeInput = ({ value = [], onChange }: PropertyTypeInputProps) => {
    // Map value array to option objects for Autocomplete
    const selectedOptions = PROPERTY_TYPES.filter((opt) =>
        value.map((v) => v.toLowerCase()).includes(opt.value.toLowerCase()),
    );

    return (
        <div>
            <label className="tw-block tw-mb-1 tw-text-[14px] tw-text-[#555E67]">Type</label>
            <Autocomplete
                multiple
                options={PROPERTY_TYPES}
                getOptionLabel={(option) => option.label}
                value={selectedOptions}
                onChange={(_, newValue) => onChange(newValue.map((opt) => opt.value))}
                isOptionEqualToValue={(option, val) => option.value.toLowerCase() === val.value.toLowerCase()}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            label={option.label}
                            {...getTagProps({ index })}
                            sx={{
                                background: "#FFE3D1",
                                color: "#E26A2C",
                                fontWeight: 500,
                                fontSize: 14,
                            }}
                        />
                    ))
                }
                renderOption={(props, option, { selected }) => (
                    <li {...props} key={option.value} style={{ borderRadius: 8, margin: 4, paddingLeft: 8 }}>
                        <Checkbox
                            checked={selected}
                            sx={{
                                color: "var(--orange)",
                                "&.Mui-checked": {
                                    color: "var(--orange)",
                                },
                                marginRight: 1,
                            }}
                        />
                        <ListItemText
                            primary={option.label}
                            primaryTypographyProps={{
                                fontWeight: 400,
                                color: "#222",
                                fontSize: 18,
                            }}
                        />
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select property type"
                        size="small"
                        InputProps={{ ...params.InputProps, sx: { borderRadius: 2 } }}
                    />
                )}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        paddingY: "6px",
                        borderRadius: 2,
                        borderColor: "var(--orange)",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "var(--orange)",
                    },
                }}
            />
        </div>
    );
};

export default PropertyTypeInput;
